import Bowser from "bowser"
const getOSName = () => Bowser.getParser(window.navigator.userAgent).getOS().name
export default getOSName